module.exports = __webpack_public_path__ + "img/badge_amilon.79c164d1.jpg";